import { GridColDefPro } from '@/global/components/DataGrid/utils/types'
import { Link } from '@mui/material'
import dayjs from 'dayjs'
import ContentGuide from 'global/guides/ContentGuide'
import { TarefaDesenvolvimento, desenvolvimento } from 'service/api'
import PrazoHomologacao from './PrazoHomologacao'

const columns: GridColDefPro[] = [
    {
        field: 'referencia',
        headerName: 'Referência',
        width: 120,
        renderCell: ({ row }) => (
            <Link href={row.url} target="_blank" rel="noopener noreferrer">
                {row.referencia}
            </Link>
        ),
    },
    {
        field: 'titulo',
        headerName: 'Nome da issue',
        flex: 1,
        minWidth: 280,
    },
    {
        field: 'cobranca',
        headerName: 'Cobrança',
        width: 120,
        type: 'boolean',
    },
    {
        field: 'status',
        headerName: 'Status',
        width: 160,
    },
    {
        field: 'createdAt',
        headerName: 'Criada em',
        width: 160,
        type: 'date',
        valueFormatter: ({ value }) =>
            value ? dayjs(value).format('DD/MM/YYYY HH:mm') : null,
    },
]

interface Props {
    clienteId: number
    criadoEm?: string | Date
}

class Erro extends Error {
    constructor() {
        super()
        this.message = 'Confira as credenciais da integração e tente novamente.'
        this.name = 'Erro ao buscar as tarefas do GitHub'
    }
}

export default function GridDesenvolvimento({ clienteId, criadoEm }: Props) {
    const {
        data = [],
        isLoading,
        isError,
    } = desenvolvimento.useFetch<TarefaDesenvolvimento[]>({
        queryParams: { clienteId: String(clienteId) },
        enabled: Boolean(clienteId),
    })

    return (
        <ContentGuide.DataGrid
            loading={isLoading}
            defaultPageSize={10}
            columns={columns}
            rows={data}
            components={{
                Footer: () => <PrazoHomologacao criadoEm={criadoEm} />,
            }}
            ToolbarProps={{
                exportButtonProps: {
                    fileName: 'exportacao-desenvolvimento',
                },
                showQuickFilter: true,
            }}
            error={isError ? new Erro() : undefined}
        />
    )
}
